/*
 * @Author: 王丛
 * @Date: 2021-12-31 15:49:47
 * @LastEditors: zhuguoqin zhuguoqin@chunyu.me
 * @LastEditTime: 2023-05-17 16:03:04
 * @Description: file content
 */
import Vue from 'vue';
import VueRouter from 'vue-router';
import NativeBridge from '@cy/native-bridge';

Vue.use(VueRouter);

// 解决编程式路由往同一地址跳转时会报错的情况
const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;
// push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};
// replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch(err => err);
};

const routes = [
  {
    path: '/hospital-list',
    name: 'HospitalList',
    component: () =>
      import(
        /* webpackChunkName: 'HospitalList' */ '@/views/HospitalList/index.vue'
      ),
    meta: {
      title: '医院列表',
    },
  },
  {
    path: '/drug-storehouse',
    name: 'DrugStorehouse',
    component: () =>
      import(
        /* webpackChunkName: 'DrugStorehouse' */ '@/views/DrugStorehouse/index.vue'
      ),
    meta: {
      title: '药品库',
    },
  },
  {
    path: '/disease-bank',
    name: 'DiseaseBank',
    component: () =>
      import(
        /* webpackChunkName: 'DiseaseBank' */ '@/views/DiseaseBank/index.vue'
      ),
    meta: {
      title: '疾病库',
    },
  },
  {
    path: '/self-examination',
    name: 'SelfExamination',
    component: () =>
      import(
        /* webpackChunkName: 'SelfExamination' */ '@/views/SelfExamination/index.vue'
      ),
    meta: {
      title: '自诊自查',
    },
  },
  {
    path: '/search-polymerization',
    name: 'SearchPolymerization',
    component: () =>
      import(
        /* webpackChunkName: 'SearchPolymerization' */ '@/views/SearchPolymerization/index.vue'
      ),
    meta: {
      title: '搜索',
    },
  },
  {
    path: '/modify-self-inspection',
    name: 'ModifySelfInspection',
    component: () =>
      import(
        /* webpackChunkName: 'ModifySelfInspection' */ '@/views/ModifySelfInspection/index.vue'
      ),
    meta: {
      title: '修改自查条件',
    },
  },
  {
    path: '/free-clinic',
    name: 'FreeClinic',
    component: () =>
      import(
        /* webpackChunkName: 'FreeClinic' */ '@/views/FreeClinic/index.vue'
      ),
    meta: {
      title: '特惠义诊',
    },
  },
  {
    path: '/authoritative-expert',
    name: 'AuthoritativeExpert',
    component: () =>
      import(
        /* webpackChunkName: 'AuthoritativeExpert' */ '@/views/AuthoritativeExpert/index.vue'
      ),
    meta: {
      title: '权威专家',
    },
  },
  {
    path: '/psychological-counseling',
    name: 'PsychologicalCounseling',
    component: () =>
      import(
        /* webpackChunkName: 'PsychologicalCounseling' */ '@/views/PsychologicalCounseling/index.vue'
      ),
    meta: {
      title: '心理咨询热线',
    },
  },
  {
    path: '/company-psychological-counseling',
    name: 'CompanyPsychologicalCounseling',
    component: () =>
      import(
        /* webpackChunkName: 'CompanyPsychologicalCounseling' */ '@/views/CompanyPsychologicalCounseling/index.vue'
      ),
    meta: {
      title: 'G7心理咨询热线',
    },
  },
  {
    path: '/pay-success',
    name: 'PaySuccess',
    component: () =>
      import(
        /* webpackChunkName: 'PaySuccess' */ '@/views/PaySuccess/index.vue'
      ),
    meta: {
      title: '购买成功',
    },
  },
  {
    path: '/add-adviser',
    name: 'AddAdviser',
    component: () =>
      import(
        /* webpackChunkName: 'AddAdviser' */ '@/views/AddAdviser/index.vue'
      ),
    meta: {
      title: '联系顾问',
    },
  },
  {
    path: '/recommend-goodat',
    name: 'RecommendGoodat',
    component: () =>
      import(
        /* webpackChunkName: 'RecommendGoodat' */ '@/views/RecommendGoodat/index.vue'
      ),
    meta: {
      title: '推荐擅长',
    },
  },
  {
    path: '/anniversary-11',
    name: 'Anniversary11',
    component: () =>
      import(
        /* webpackChunkName: 'Anniversary11' */ '@/views/Anniversary11/index.vue'
      ),
    meta: {
      title: '春雨医生11周年庆盛典',
    },
  },
  {
    path: '/physician-day',
    name: 'PhysicianDay',
    component: () =>
      import(
        /* webpackChunkName: 'PhysicianDay' */ '@/views/PhysicianDay/index.vue'
      ),
    meta: {
      title: '致敬了不起的平凡',
    },
  },
  {
    path: '/physician-day-clinic',
    name: 'PhysicianDayClinic',
    component: () =>
      import(
        /* webpackChunkName: 'PhysicianDayClinic' */ '@/views/PhysicianDayClinic/index.vue'
      ),
    meta: {
      title: '致敬了不起的平凡',
    },
  },
  {
    path: '/doctor-assess-list',
    name: 'AssessList',
    component: () =>
      import(
        /* webpackChunkName: 'AssessList' */ '@/views/AssessList/index.vue'
      ),
    meta: {
      title: '患者评价',
    },
  },
  {
    path: '/dicom-upload',
    name: 'DicomUpload',
    component: () =>
      import(
        /* webpackChunkName: 'DicomUpload' */ '@/views/DicomUpload/upload.vue'
      ),
    meta: {
      title: '添加文件',
    },
  },
  {
    path: '/dicom-view',
    name: 'DicomView',
    component: () =>
      import(/* webpackChunkName: 'DicomView' */ '@/views/DicomView/index.vue'),
    meta: {
      title: '医学影像文件查看',
    },
  },
  {
    path: '/dicom-upload-result',
    name: 'DicomUploadResult',
    component: () =>
      import(
        /* webpackChunkName: 'DicomUploadResult' */ '@/views/DicomUpload/result.vue'
      ),
    meta: {
      title: '添加文件',
    },
  },
  {
    path: '/dicom-middle-page',
    name: 'DicomMiddlePage',
    component: () =>
      import(
        /* webpackChunkName: 'DicomMiddlePage' */ '@/views/DicomUpload/middle-page.vue'
      ),
    meta: {
      title: '医学影像文件查看',
    },
  },
  {
    path: '/qing-xin-project',
    name: 'QingXinProject',
    component: () =>
      import(
        /* webpackChunkName: 'QingXinProject' */ '@/views/QingXinProject/index.vue'
      ),
    meta: {
      title: '青心计划，让心更轻一点',
    },
  },
  {
    path: '/qing-xin-project/task',
    name: 'QingXinTask',
    component: () =>
      import(
        /* webpackChunkName: 'QingXinTask' */ '@/views/QingXinProject/activityTask.vue'
      ),
    meta: {
      title: '做任务赢金币',
    },
  },
  {
    path: '/qingxin-disseminate',
    name: 'QingXinDisseminate',
    component: () =>
      import(
        /* webpackChunkName: 'QingXinDisseminate' */ '@/views/QingXinDisseminate/index.vue'
      ),
    meta: {
      title: '春雨医生公益活动-青心计划',
    },
  },
  {
    path: '/qingxin-disseminate/bill',
    name: 'QingXinDisseminateBill',
    component: () =>
      import(
        /* webpackChunkName: 'QingXinDisseminateBill' */ '@/views/QingXinDisseminate/bill.vue'
      ),
    meta: {
      title: '做任务赢金币',
    },
  },
  {
    path: '/caring-elder/task',
    name: 'CaringElderTask',
    component: () =>
      import(
        /* webpackChunkName: 'CaringElderTask' */ '@/views/CaringElder/goldenTask.vue'
      ),
    meta: {
      title: '做任务赢金币',
    },
  },
  {
    path: '/caring-elder/entry',
    name: 'CaringElderEntry',
    component: () =>
      import(
        /* webpackChunkName: 'CaringElderEntry' */ '@/views/CaringElder/entry.vue'
      ),
    meta: {
      title: '银发生活欢乐多-春雨医生公益活动',
    },
  },
  {
    path: '/caring-elder/bill',
    name: 'CaringElderBill',
    component: () =>
      import(
        /* webpackChunkName: 'CaringElderBill' */ '@/views/CaringElder/bill.vue'
      ),
    meta: {
      title: '预览海报',
    },
  },
  {
    path: '/common-activity',
    name: 'CommonActivity',
    component: () =>
      import(
        /* webpackChunkName: 'CommonActivity' */ '@/views/CommonActivity/index.vue'
      ),
    meta: {
      title: '幸好有你 点亮新年',
    },
  },
  {
    path: '/common-activity/annual-record',
    name: 'AnnualRecord',
    component: () =>
      import(
        /* webpackChunkName: 'AnnualRecord' */ '@/views/CommonActivity/AnnualRecord.vue'
      ),
    meta: {
      title: '春雨医生年度回顾',
    },
  },
  {
    path: '/common-activity/lottery',
    name: 'AnnualLottery',
    component: () =>
      import(
        /* webpackChunkName: 'AnnualLottery' */ '@/views/CommonActivity/Lottery.vue'
      ),
    meta: {
      title: '春雨医生年度回顾',
    },
  },
  {
    path: '/live-list',
    name: 'LiveList',
    component: () =>
      import(/* webpackChunkName: 'LiveList' */ '@/views/LiveList/index.vue'),
    meta: {
      title: '直播列表',
    },
  },
  {
    path: '/kangle',
    name: 'KangLe',
    component: () =>
      import(/* webpackChunkName: 'KangLe' */ '@/views/KangLe/index.vue'),
    meta: {
      title: '春雨康乐',
    },
  },
  {
    path: '/abbott-instant-riding',
    name: 'AbbottInstantRiding',
    component: () =>
      import(
        /* webpackChunkName: 'AbbottInstantRiding' */ '@/views/AbbottInstantRiding/index.vue'
      ),
    meta: {
      title: '有谱走遍天下 助力赢取好礼',
    },
  },
  {
    path: '/abbott-instant-img-list',
    name: 'AbbottInstantImgList',
    component: () =>
      import(
        /* webpackChunkName: 'AbbottInstantImgList' */ '@/views/AbbottInstantImgList/index.vue'
      ),
    meta: {
      title: '骑行花絮',
    },
  },
  {
    path: '/clinic-reserve',
    name: 'ClinicReserve',
    component: () =>
      import(
        /* webpackChunkName: 'ClinicReserve' */ '@/views/ClinicReserve/index.vue'
      ),
    meta: {
      title: '重疾门诊预约',
    },
  },
  {
    path: '/medical-testing',
    name: 'MedicalTesting',
    component: () =>
      import(
        /* webpackChunkName: 'MedicalTesting' */ '@/views/MedicalTesting/index.vue'
      ),
    meta: {
      title: '医疗检测',
    },
  },
  {
    path: '/pdf-viewer',
    name: 'PdfViewer',
    component: () =>
      import(/* webpackChunkName: 'PdfViewer' */ '@/views/PdfViewer/index.vue'),
    meta: {
      title: 'PDF',
    },
  },
  {
    path: '/inquiry-summary',
    name: 'InquirySummary',
    component: () =>
      import(
        /* webpackChunkName: 'InquirySummary' */ '@/views/InquirySummary/index.vue'
      ),
    meta: {
      title: '问诊总结',
    },
  },
  {
    path: '/video-appointment',
    name: 'VideoAppointment',
    component: () =>
      import(
        /* webpackChunkName: 'VideoAppointment' */ '@/views/VideoInquiryAppointment/index.vue'
      ),
    meta: {
      title: '视频问诊',
    },
  },
  {
    path: '/chinese-medicine',
    name: 'ChineseMedicine',
    component: () =>
      import(
        /* webpackChunkName: 'ChineseMedicine' */ '@/views/ChineseMedicine/index.vue'
      ),
    meta: {
      title: '春雨中医馆',
    },
  },
  {
    path: '/video-inquiry',
    name: 'VideoInquiry',
    component: () =>
      import(
        /* webpackChunkName: 'VideoInquiry' */ '@/views/VideoInquiryRedirectPage/index.vue'
      ),
    meta: {
      title: '视频问诊',
    },
  },
  {
    path: '/package-detail',
    name: 'PackageDetail',
    component: () =>
      import(
        /* webpackChunkName: 'PackageDetail' */ '@/views/InquiryPackage/detail.vue'
      ),
    meta: {
      title: '',
    },
  },
  {
    path: '/my-package',
    name: 'MyPackage',
    component: () =>
      import(
        /* webpackChunkName: 'MyPackage' */ '@/views/InquiryPackage/list.vue'
      ),
    meta: {
      title: '我的套餐',
    },
  },
  {
    path: '/sanjin-urology-handbook',
    name: 'UrologyHandbook',
    component: () =>
      import(
        /* webpackChunkName: 'UrologyHandbook' */ '@/views/UrologyHandbook/index.vue'
      ),
    meta: {
      title: '2024年泌尿系统疾病预防科普手册',
    },
  },
  {
    path: '/static-qa',
    name: 'StaticQa',
    component: () =>
      import(/* webpackChunkName: 'StaticQA' */ '@/views/StaticQa/index.vue'),
    meta: {
      title: '问题详情',
    },
  },
  {
    path: '/clinic-product-list',
    name: 'ClinicProductList',
    component: () =>
      import(
        /* webpackChunkName: 'StaticQA' */ '@/views/ProductListForDoctor/index.vue'
      ),
    meta: {
      title: '推荐药品',
    },
  },
  {
    path: '/zhongyi_dashboard',
    name: 'ZhongyiDashBoard',
    component: () =>
      import(
        /* webpackChunkName: 'ZhongyiDashBoard' */ '@/views/ZhongyiDashBoard/index.vue'
      ),
    meta: {
      title: '中医代理人仪表板',
    },
  },
  {
    path: '/gsk-herpes-zoster/showcase',
    name: 'GskHerpesZosterShowcase',
    component: () =>
      import(
        /* webpackChunkName: 'GskHerpesZosterShowcase' */ '@/views/GskHerpesZoster/ImageShowcase.vue'
      ),
    meta: {
      title: '带状疱疹疾病教育科普',
    },
  },
  {
    path: '/gsk-herpes-zoster/map',
    name: 'GskHerpesZosterMap',
    component: () =>
      import(
        /* webpackChunkName: 'GskHerpesZosterMap' */ '@/views/GskHerpesZoster/MapPage.vue'
      ),
    meta: {
      title: '附近医院',
    },
  },
  {
    path: '/imguploaderchunyu',
    name: 'ImgUploaderChunyu',
    component: () =>
      import(/* webpackChunkName: 'StaticQA' */ '@/views/ImgUpload/index.vue'),
    meta: {
      title: '图片上传',
    },
  },
  {
    path: '/signature-page',
    name: 'SignaturePage',
    component: () =>
      import(
        /* webpackChunkName: 'SignaturePage' */ '@/views/SignaturePage/index.vue'
      ),
    meta: {
      title: '签名页面',
    },
  },
  {
    path: '/welcome',
    name: 'Welcome',
    component: () =>
      import(/* webpackChunkName: 'Welcome' */ '@/views/Welcome/index.vue'),
    meta: {
      title: '欢迎',
    },
  },
];
const router = new VueRouter({
  mode: 'history',
  base: 'v-m-general/', // TODO: 需更改为服务器给配置的url 如：v-m-mall/
  routes,
});
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || '';
  NativeBridge.setTitle('1.0', document.title);
  next();
});
export default router;
